import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';

import Header from '../../components/Header';
import List from '../../components/List';
import Grid from '../../components/Grid';
import messages from './messages';
import './styles.css';

class GoogleCalendarFormDrawer extends React.PureComponent {
  static propTypes = {
    event: PropTypes.object,
  };

  render() {
    const { event } = this.props;
    const hasAttendees = this.props.event.guests;
    if (event.allDay) {
      // for all-day events, the end date we get from google is actually the day AFTER the event has ended, so correct for that
      event.end.setDate(event.end.getDate() - 1); // developer note: this will work even on month boundaries
    }

    const eventSpansMultipleDays = (event.start.getDate() !== event.end.getDate()) ||
      (event.start.getYear() !== event.end.getYear()) ||
      (event.start.getMonth() !== event.end.getMonth());
    const startAndEndTimeZoneDiffers = (event.startTimeZone !== event.endTimeZone);

    const guestsList = (hasAttendees.length !== undefined) ? hasAttendees.map((guest) => ({
      guest: guest.displayName ? guest.displayName : guest.email,
      status: (guest.responseStatus === 'accepted') ?
        <FormattedMessage {...messages.eventStatusConfirmed} /> : <FormattedMessage {...messages.eventStatusAwaiting} />,
    })).map((guest) =>
      <List.Item key={guest.email} styleName="guests-list">{guest.guest} ({guest.status})</List.Item>) : event.guests;

    return (
      <div styleName="event-details">
        <Header as="h1" styleName="header-text">
          {event.title}
        </Header>
        <Header styleName="section-title" size="small">
          <FormattedMessage {...messages.eventDetails} />
        </Header>
        <Grid>
          <Grid.Row>
            <Grid.Column width={16} styleName="sub-title" size="small">
              <FormattedMessage {...messages.eventDate} />
              { !event.allDay && !eventSpansMultipleDays && (
              <div styleName="sidebar-text" id="one-time-event">
                <FormattedDate
                  value={event.start}
                  weekday="short"
                  month="long"
                  day="numeric"
                  timeZone={event.startTimeZone}
                />,&nbsp;
                <FormattedTime
                  value={event.start}
                  timeZone={event.startTimeZone}
                  timeZoneName={startAndEndTimeZoneDiffers ? 'short' : undefined}
                />
                &nbsp;-&nbsp;
                <FormattedTime value={event.end} timeZone={event.endTimeZone} timeZoneName="short" />
              </div>
              ) }
              { !event.allDay && eventSpansMultipleDays && (
              <div styleName="sidebar-text">
                <FormattedDate
                  value={event.start}
                  weekday="short"
                  month="long"
                  day="numeric"
                  timeZone={event.startTimeZone}
                />, &nbsp;
                <FormattedTime
                  value={event.start}
                  timeZone={event.startTimeZone}
                  timeZoneName={startAndEndTimeZoneDiffers ? 'short' : undefined}
                />
                &nbsp;-&nbsp;
                <FormattedDate
                  value={event.end}
                  weekday="short"
                  month="long"
                  day="numeric"
                  timeZone={event.endTimeZone}
                />, &nbsp;
                <FormattedTime value={event.end} timeZone={event.endTimeZone} timeZoneName="short" />
              </div>
              )}
              { event.allDay && !eventSpansMultipleDays && (
              <div styleName="sidebar-text">
                <FormattedDate
                  value={event.start}
                  weekday="short"
                  month="long"
                  day="numeric"
                  timeZone={event.startTimeZone}
                />&nbsp;-&nbsp;
                <FormattedMessage {...messages.eventAllDay} />
              </div>
              ) }
              { event.allDay && eventSpansMultipleDays && (
              <div styleName="sidebar-text">
                <FormattedDate value={event.start} weekday="short" month="long" day="numeric" timeZone={event.startTimeZone} />
                &nbsp;-&nbsp;
                <FormattedDate value={event.end} weekday="short" month="long" day="numeric" timeZone={event.endTimeZone} />&nbsp;-&nbsp;
                <FormattedMessage {...messages.eventAllDay} />
              </div>
              ) }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column styleName="sub-title">
              <FormattedMessage {...messages.eventPlace} />
              <div styleName="sidebar-text">
                {event.location}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column styleName="sub-title">
              <FormattedMessage {...messages.eventGuests} />
              <div styleName="sidebar-text">
                {guestsList}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column styleName="sub-title">
              <FormattedMessage {...messages.eventDescription} />
              <div styleName="sidebar-text">
                {event.description}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column styleName="sub-title">
              <Link href={event.seeMoreLink} target="_blank">
                <FormattedMessage
                  {...messages.eventMoreDetails}
                  values={{
                    b: (...chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default GoogleCalendarFormDrawer;
